import { AuthContext } from "@sagecentral/core-ui";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AuthHelperUI from "./AuthHelperUI";

const Login = () => {
    const location = useLocation();
    const auth = useContext(AuthContext);
    
    useEffect(() => {
        if (auth === null) return;
        auth.signinRedirect(location.state?.returnToPath || '/');
    }, [ auth ]);

    return (
        <AuthHelperUI> Logging you in </AuthHelperUI>
    );
};

export default Login;